<!--
    BlockRenderer — read-only display of ProseMirror JSON content.

    Frontend counterpart to TextContentRenderer.php. Use this inside Vue templates
    where you need to display block editor content without making it editable.

    Usage:
        <block-renderer :content="proseMirrorJson" />
-->
<template>
    <div class="block-renderer" v-html="html"></div>
</template>

<script>
import { generateHTML } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'

const EXTENSIONS = [
    StarterKit.configure({
        blockquote: false,
        bold: false,
        code: false,
        codeBlock: false,
        horizontalRule: false,
        italic: false,
        orderedList: false,
        strike: false,
        heading: { levels: [1, 2, 3, 4, 5, 6] },
    }),
    Link.configure({ openOnClick: false }),
]

export default {
    props: {
        content: { type: Object, default: null },
    },

    computed: {
        html() {
            if (!this.content || !this.content.type) {
                return ''
            }
            try {
                return generateHTML(this.content, EXTENSIONS)
            } catch (e) {
                return ''
            }
        },
    },
}
</script>

<style>
.block-renderer h1 { font-size: 1.5em;  font-weight: 600; margin-top: 0.5em; margin-bottom: 0.25em; }
.block-renderer h2 { font-size: 1.3em;  font-weight: 600; margin-top: 0.5em; margin-bottom: 0.25em; }
.block-renderer h3 { font-size: 1.15em; font-weight: 600; margin-top: 0.5em; margin-bottom: 0.25em; }
.block-renderer h4 { font-size: 1.05em; font-weight: 600; margin-top: 0.5em; margin-bottom: 0.25em; }
.block-renderer h5 { font-size: 0.95em; font-weight: 600; margin-top: 0.5em; margin-bottom: 0.25em; }
.block-renderer h6 { font-size: 0.85em; font-weight: 600; margin-top: 0.5em; margin-bottom: 0.25em; }
.block-renderer ul  { padding-left: 1.4em; margin-bottom: 0.5em; }
.block-renderer a   { color: #007bff; text-decoration: underline; }
</style>



// WEBPACK FOOTER //
// src/Assets/components/Common/BlockRenderer.vue